<template>
    <!-- The wrapper class + data attribute stay: article-cta scroll-to-existing-form
        targets `.form-embed__wrapper[data-form-uuid]`. -->
    <div
        v-if="form"
        v-editable="blok"
        class="form-embed__wrapper"
        :data-form-uuid="blok.form"
    >
        <StoryblokForm
            :key="schemaKey"
            :definition="form"
            :form-id="blok.form"
            :send="sendRequest"
            @submitted="capture('lead_submitted', trackingProperties)"
            @submit-error="capture('lead_submit_error', trackingProperties)"
        />
    </div>
</template>

<script setup>
import StoryblokForm from '~/components/storyblok-form/storyblok-form.vue'
import { sendRequest } from '~/utils/forms'

const props = defineProps({
    blok: {
        type: Object,
        required: true,
    },
})

const { capture } = useTracking()
const trackingProperties = { form: 'storyblok-form', form_id: props.blok.form, surface: 'embed' }

const { data: form } = await useAsyncData(`form-${props.blok.form}`, () => $fetch(`/api/form-embed?uuid=${props.blok.form}`))

// The normalized schema is immutable for one renderer mount, so a Visual Editor change
// to the field definitions must remount the renderer with a fresh default-value shape.
const schemaKey = computed(() => JSON.stringify(form.value?.fields ?? []))
</script>

<style lang="scss">
@use 'form-embed';
</style>
